var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26562 9.73718C2.26562 11.2856 2.4473 12.7237 2.64547 14.2524C2.86027 15.9095 2.81701 17.6377 2.81701 19.3067C2.81701 22.4253 2.86021 25.5556 2.7006 28.6679C2.44549 33.6426 2.3759 38.6051 2.3759 43.592",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71289 2.01782C1.71289 2.2138 1.74352 2.29964 1.82317 2.45893",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6106 8.77228C18.6106 10.0479 18.8669 11.3902 19.1068 12.6381C19.3753 14.0338 19.3597 15.7092 19.1865 17.1165C18.9328 19.1781 18.9558 21.3102 18.8373 23.3839C18.6952 25.8707 18.8312 28.4108 18.8312 30.901C18.8312 34.2097 18.8373 39.967 18.8373 43.2797C18.9414 44.4055 18.9414 42.2756 18.9414 41.8551C18.9414 41.171 18.9414 40.4869 18.9414 39.8028C18.9414 37.2383 18.5094 34.7013 18.6167 32.1263C18.684 30.5124 18.9821 28.9468 19.2171 27.3538C19.4689 25.6476 19.6717 23.9544 19.8481 22.2382C19.9942 20.818 20.3332 19.3912 20.5956 17.9865C20.8779 16.4751 21.0762 14.8958 21.6922 13.4713C22.5016 11.5995 23.9025 10.1894 25.9256 9.76476C27.0508 9.5286 28.2849 9.65449 29.4299 9.65449C30.8077 9.65449 32.0037 9.73475 33.3263 10.1569C35.7525 10.9312 37.5395 13.3062 38.5216 15.5359C39.6835 18.1737 40.0763 20.8442 40.3963 23.6779C41.0813 29.7453 41.8789 35.8505 41.8789 41.9654",
    stroke: "#B00487",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/IN.6a8d5d2d71037a03063f5fdd9a17f577.svg";
export { ForwardRef as ReactComponent };